import { AuthAction, AuthActionTypes } from './auth.actions';

export const AUTH_FEATURE_KEY = 'auth';

/**
 * Interface for the 'Auth' data used in
 *  - AuthState, and
 *  - authReducer
 *
 *  Note: replace if already defined in another module
 */

/* tslint:disable:no-empty-interface */
export interface User {
  username: string;
  firstName?: string;
  lastName?: string;
  email: string;
  mobile?: string;
  token?: string;
  roles: string[];
  groups: string[];
}

export interface Token {
  access_token: string;
  refresh_token: string
}

export interface AuthState {
  user: User; // current logged in User
  loaded: boolean; // has the Auth list been loaded
  loading: boolean;
  error?: any; // last none error (if any)
}

export interface AuthPartialState {
  readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const initialState: AuthState = {
  user: undefined,
  loaded: true,
  loading: false
};

export function authReducer(
  state: AuthState = initialState,
  action: AuthAction
): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN:
    case AuthActionTypes.GET_USER_DETAILS:
      return {
        ...state,
        loaded: false,
        loading: true,
        error: undefined
      };

    case AuthActionTypes.LOGIN_SUCCESS:
    case AuthActionTypes.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        loaded: true
      };

    case AuthActionTypes.GET_USER_DETAILS_FAIL:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload
      };

    case AuthActionTypes.LOGOUT:
      return initialState;

    case AuthActionTypes.LOGIN_FAIL:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: 'Incorrect username and/or password'
      };

    default:
      return state;
  }
}
